import { render, staticRenderFns } from "./positiondetail.vue?vue&type=template&id=02f6c809&scoped=true&"
import script from "./positiondetail.vue?vue&type=script&lang=js&"
export * from "./positiondetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6c809",
  null
  
)

export default component.exports